<div class="alert-settings">
  <div class="toolbar">
    <mat-form-field appearance="outline" class="filter-field" subscriptSizing="dynamic">
      <mat-label>{{ 'corporationAlertSettings.filterAlertTypes' | transloco }}</mat-label>
      <input matInput [(ngModel)]="filterText" (ngModelChange)="applyFilter()" data-testid="alert-settings-filter" />
    </mat-form-field>
    @if (canManageEnabled) {
      <mat-checkbox [(ngModel)]="enabledOnly" (change)="applyFilter()" data-testid="alert-settings-enabled-only">
        {{ 'corporationAlertSettings.enabledOnly' | transloco }}
      </mat-checkbox>
    }
    <span class="spacer"></span>
    @if (changeCount > 0) {
      <span class="muted">{{ (changeCount === 1 ? 'corporationAlertSettings.unsavedChange' : 'corporationAlertSettings.unsavedChanges') | transloco: { count: changeCount } }}</span>
    }
    <span class="saved-status" aria-live="polite">{{ changeCount === 0 ? statusMessage : '' }}</span>
    <button mat-stroked-button type="button" (click)="discardChanges()" [disabled]="changeCount === 0 || saving"
      data-testid="alert-settings-discard">
      {{ 'corporationAlertSettings.discard' | transloco }}
    </button>
    <button mat-raised-button color="accent" type="button" (click)="save()" [disabled]="changeCount === 0 || saving"
      data-testid="alert-settings-save">
      {{ 'common.buttons.save' | transloco }}
    </button>
  </div>

  @if (loading) {
    <div class="muted">{{ 'corporationAlertSettings.loading' | transloco }}</div>
  } @else if (rows.length === 0) {
    <div class="muted">
      {{ (canManageEnabled ? 'corporationAlertSettings.noAlertTypesYet' : 'corporationAlertSettings.noAlertsEnabled') | transloco }}
    </div>
  } @else if (tableRows.length === 0) {
    <div class="muted">{{ 'corporationAlertSettings.noAlertTypesMatchFilter' | transloco }}</div>
  } @else {
    <table mat-table [dataSource]="tableRows" class="alert-settings-table">
      <ng-container matColumnDef="group">
        <td mat-cell *matCellDef="let group" [attr.colspan]="displayedColumns.length" class="group-cell">
          <div class="group-header">
            @if (canManageEnabled) {
              <mat-checkbox
                [checked]="isGroupFullyEnabled(group)"
                [indeterminate]="isGroupPartiallyEnabled(group)"
                (change)="setGroupEnabled(group, $event.checked)"
                [aria-label]="'corporationAlertSettings.enableAllGroupAlertsShown' | transloco: { group: group.label }">
              </mat-checkbox>
            }
            <span class="group-label">{{ group.label }}</span>
            @if (canManageEnabled) {
              <span class="muted">{{ 'corporationAlertSettings.enabledCount' | transloco: { enabled: enabledCount(group.rows), total: group.rows.length } }}</span>
            }
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="enabled">
        <th mat-header-cell *matHeaderCellDef class="enabled-cell">{{ 'corporationAlertSettings.enabled' | transloco }}</th>
        <td mat-cell *matCellDef="let row" class="enabled-cell">
          <mat-checkbox [(ngModel)]="row.enabled" [aria-label]="'corporationAlertSettings.enableAlertType' | transloco: { name: alertTypeName(row) }"></mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>{{ 'corporationAlertSettings.alertType' | transloco }}</th>
        <td mat-cell *matCellDef="let row">{{ alertTypeName(row) }}</td>
      </ng-container>

      <ng-container matColumnDef="severity">
        <th mat-header-cell *matHeaderCellDef class="severity-cell">{{ 'common.labels.severity' | transloco }}</th>
        <td mat-cell *matCellDef="let row" class="severity-cell">
          <mat-form-field appearance="outline" class="severity-field" subscriptSizing="dynamic">
            <mat-select [(ngModel)]="row.severity" [disabled]="!row.enabled" [aria-label]="'corporationAlertSettings.severityFor' | transloco: { name: alertTypeName(row) }">
              <mat-option [value]="defaultSeverity">{{ 'corporationAlertSettings.defaultSeverity' | transloco: { severity: (row.alertType.defaultAlertSeverityID | enumLabel:'alertSeverity') } }}</mat-option>
              @for (option of severityOptions; track option.value) {
                <mat-option [value]="option.value">{{ option.label }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let group; columns: ['group']; when: isGroupRow" class="group-row"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" [class.changed-row]="isRowChanged(row)"></tr>
    </table>
  }
</div>
